import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

type ErrorData = {
  message: string;
};

export function isFetchBaseQueryError(
  error?: FetchBaseQueryError | SerializedError
): error is FetchBaseQueryError & { data: ErrorData } {
  if (!error) {
    return false;
  }
  return 'status' in error && 'data' in error;
}
